<template>
  <div id="app">
    <router-view></router-view> 

  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
 
  }
}
</script>

<style>
 #app {
   width: 100vw;
   height: 100vh;
   overflow: hidden;
 }html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}individual

.van-nav-bar__title {
  font-weight: 400;
  font-size: 18px;
  color: #060606;
}
.van-nav-bar .van-icon {
    color: #333 !important;
}
</style>
